export default __webpack_public_path__ + "images/f22936c6c3f0deb31284fd3d071e859a.svg";